import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LicenseContext = createContext({ status: null, hasAddon: () => true, reload: () => {} });

export const useLicense = () => useContext(LicenseContext);

export const LicenseProvider = ({ children }) => {
  const [status, setStatus] = useState(null);
  const reload = useCallback(() => axios.get(`${API}/public/license-status`).then(r => setStatus(r.data)).catch(() => {}), []);

  useEffect(() => {
    reload();
    const t = setInterval(reload, 300000);
    const id = axios.interceptors.response.use(undefined, (error) => {
      const code = error.response?.data?.code;
      if (code === 'LICENSE_EXPIRED') setStatus(s => ({ ...(s || {}), active: false }));
      if (code === 'ADDON_DISABLED') reload();
      return Promise.reject(error);
    });
    return () => { clearInterval(t); axios.interceptors.response.eject(id); };
  }, [reload]);

  const hasAddon = (key) => !status || status.addons?.[key] !== false;
  return <LicenseContext.Provider value={{ status, hasAddon, reload }}>{children}</LicenseContext.Provider>;
};
